/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Polyline, Ellipse, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function TextAa(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Polyline
        points="152 192 80 56 8 192"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Ellipse
        cx={208}
        cy={166.9}
        rx={32}
        ry={28}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M183.9948,112.38439A34.03967,34.03967,0,0,1,208,102.9c17.67311,0,32,12.536,32,28V192"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={130.82351}
        y1={152}
        x2={29.17645}
        y2={152}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default TextAa;
